<template>
	<div>
		<section class="support">
			<div class="container">
				<h2 class="title text-center mt-3">
					<span>Anggota</span> Dari
				</h2>
				<div class="row justify-content-center py-5">
					<!-- Gambar 1 -->
					<div class="col-md-4 position-relative text-center mb-4">
						<img class="img-fluid img-uniform-height" :src='"../assets/images/support/Logo_Kemko.png"' alt="logo">
					</div>
					<!-- Gambar 2 -->
					<div class="col-md-4 position-relative text-center mb-4">
						<img class="img-fluid img-uniform-height logo-hover" :src='"../assets/images/support/Logo_Afsi.png"' alt="logo">
						<div class="hover-text">
							Nomor terdaftar: 016/CERT/FIN/IV/2024
						</div>
					</div>
					<!-- Gambar 3 -->
					<div class="col-md-4 position-relative text-center mb-4">
						<img class="img-fluid img-uniform-height logo-hover" :src='"../assets/images/support/Logo_Aftech.png"' alt="logo">
						<div class="hover-text">
							Nomor terdaftar: 138/REG/AFT/SU
						</div>
					</div>
				</div>
				<p class="text-center">
					Terdaftar di OJK berdasarkan<br>Surat Nomor S-61/IK.01/2025
				</p>
			</div>
		</section>
	</div>
</template>

<script>
export default {
	name: 'Support',
};
</script>


<style scoped>
.img-uniform-height {
	height: 150px;
	object-fit: contain;
	transition: transform 0.3s ease;
}

.logo-hover:hover {
	transform: scale(1.1);
}

.hover-text {
	position: absolute;
	bottom: 10px;
	left: 50%;
	transform: translateX(-50%);
	background-color: rgba(0, 0, 0, 0.7);
	color: white;
	padding: 5px 10px;
	border-radius: 5px;
	opacity: 0;
	transition: opacity 0.3s ease;
	font-size: 0.9rem;
}

.position-relative:hover .hover-text {
	opacity: 1;
}
</style>


// WEBPACK FOOTER //
// src/components/support.vue